module.exports = __webpack_public_path__ + "static/media/koala.46b00d9b.png";